import './Pagination.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { setPage } from "../../slices/filterSlice";

import { KeyboardArrowLeft } from "@mui/icons-material";
import { KeyboardArrowRight } from "@mui/icons-material";

export const Pagination = ({ meta }) => {
    const dispatch = useDispatch();
    const page = useSelector((state) => state.filters.page);

    if (!meta) return null;

    const { last_page } = meta;
    const { total } = meta;

    return (
        <div className={"pagination"}>
            <div className={"pagination_container"}>
                <div className={`pagination_link ${page === 1 ? "--disabled" : ""}`} onClick={() => page > 1 && dispatch(setPage(page - 1))}>
                    <KeyboardArrowLeft style={{fontSize: "18px"}}/>
                    {"Назад"}
                </div>
                <div className={"pagination_counter"}>
                    <div className={"pagination_page"}>
                        {`Текущая страница ${page} из ${last_page}`}
                    </div>
                    <div className={"pagination_total"}>
                        {`Всего элементов ${total}`}
                    </div>
                </div>
                <div className={`pagination_link ${page === last_page ? "--disabled" : ""}`} onClick={() => page < last_page && dispatch(setPage(page + 1))}>
                    {"Вперед"}
                    <KeyboardArrowRight style={{fontSize: "18px"}}/>
                </div>
            </div>
        </div>
    )
}